import { render, staticRenderFns } from "./NonGeoPicklStats.vue?vue&type=template&id=37dfeb3c&scoped=true&"
import script from "./NonGeoPicklStats.vue?vue&type=script&lang=js&"
export * from "./NonGeoPicklStats.vue?vue&type=script&lang=js&"
import style0 from "./NonGeoPicklStats.vue?vue&type=style&index=0&id=37dfeb3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dfeb3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37dfeb3c')) {
      api.createRecord('37dfeb3c', component.options)
    } else {
      api.reload('37dfeb3c', component.options)
    }
    module.hot.accept("./NonGeoPicklStats.vue?vue&type=template&id=37dfeb3c&scoped=true&", function () {
      api.rerender('37dfeb3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/NonGeoPicklStats.vue"
export default component.exports